import React from "react";
import RealMeIcon from "../../../assets/images/realme-icon.svg";
import SubmitButton from "../../Buttons/SubmitButton";
import loginEnvMap from "../../../config.js";

export const AttemptsExhausted = () => {
  const handleLogin = () => {
    const env = (window.env || "").toLowerCase();
    const apiUrl = process.env.REACT_APP_API_URL;
    const loginUrl = apiUrl ? `${apiUrl}/saml/login` : "/api/saml/login";
    window.location.href = loginEnvMap[env] || loginUrl;
  };
  return (
    <>
      <div className="intro">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Kua takiputa koe
        </h1>
        <hr />
        <h1 className="intro-title">You've been logged out</h1>

        <div className="step-container">
          <p className="mb-4">
            You've had three failed attempts to enter the correct details and
            have been logged out for your security.
          </p>
          <p className="mb-4">Log in again to continue your application.</p>
        </div>
        <div className="step-button-container">
          <SubmitButton
            text={"Log in"}
            onClick={handleLogin}
            Icon={RealMeIcon}
            className="login-btn"
          />
        </div>
      </div>
    </>
  );
};

export default AttemptsExhausted;
